/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from 'react-translated';
import { Row, Col, Tab, Badge, Nav } from 'react-bootstrap';
import Messages from './messages-tables/Messages';
import { messagesTableActions } from '../../store/actions/messagesTableActions';
import { ADMIN_MESSAGES_PAGINATION_LIMIT } from '../../config/constants';

function TabTitle(props) {
    const { title, count } = props;
    return (
        <>
            <span className="tab-title tab-title--uppercase"><Translate text={title} /></span>
            { count &&
            <Badge variant="primary">{ count }</Badge>
            }
        </>
    );
}

function MessageTable() {
    const dispatch = useDispatch();

    const postMessageTable = useSelector(state => state.postMessageTable);

    // State data.
    const [key, setKey] = useState('messages');
    const [currentPage, setCurrentPage] = useState(1);
    const [resultsNum, setResultsNum] = useState(ADMIN_MESSAGES_PAGINATION_LIMIT);
    // Updated changes.
    useEffect(() => {
        if (postMessageTable.success) {
            dispatch(messagesTableActions.getMessageTable('adminmessages',
                {
                    page: 1,
                    numberOfRecords: resultsNum
                },
                true));
        }
    }, [postMessageTable]);

    return (
        <Row className="mt-2">
            <Col>
                <Tab.Container defaultActiveKey={key} onSelect={(k) => setKey(k)}>
                    <Row>
                        <Col md={12}>
                            <Nav role="tablist" as="nav" className={'nav-tabs small mb-0'}>
                                <Nav.Item as={Nav.Link} eventKey="messages">
                                    <TabTitle title="Messages" />
                                </Nav.Item>
                            </Nav>
                        </Col>
                    </Row>
                    <Row className={'mt-0'}>
                        <Col md={12}>
                            <Tab.Content>
                                <Tab.Pane eventKey="messages">
                                    <Messages isActive={ key == 'messages' } resultsNum={resultsNum} setResultsNum={setResultsNum} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Col>
        </Row>
    );
}

export default MessageTable;
